<template>
  <div class="home">
    <barra />

    <main id="main">
         <recupero />
    </main>

 
  </div>
</template>

<script>
import barra from "@/components/barra/index.vue";
import recupero from "@/components/botonPago/recupero/index.vue";

export default {
  name: "recuperobp",
  components: {
    recupero,
    barra,
  },
};
</script>
